import React, {Fragment} from 'react';
import {Card, CardBody} from "reactstrap";
import Switch from '@mui/material/Switch';
import "./optmanage.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import {Button} from "reactstrap";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faXmark} from "@fortawesome/free-solid-svg-icons/faXmark";
import requestApi from "../../../../services/requestApi.service";
import {
    decodeString,
    parseJSON,
    randstr, replaceStringTohtml,
    showToast,handleErrorResponse
} from "../../../../Common/Appcommon";
import QuickReplyOperations from "../../../QuickReply/QuickReplyOperations";
import WebsiteWidget from "../../Integrations/IntegrationWidgets/WebsiteWidget";
import cx from "classnames";

class OptInOutManagement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            optOutKeywords : ['Stop','Unsubscribe',"Opt out"],
            optInKeywords : ['Start','Subscribe', 'Opt in'],
            switchStatus : [true, true, true],
            modalStatus : [false, false],
            currentOptType : "",
            optInMsgId : "",
            optOutMsgId : "",
            optInResponseMessage : "",
            optOutResponseMessage : "",
            requiredindex : []
        }

    }

    componentDidMount = async () => {
        await this.loadOptManagementData();
    };

    loadOptManagementData = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "OPT_MANAGEMENT",
            "SETTINGSNAME" : "GET_ALL",
        }
        let res = await requestApi.processServerRequest(params);
        if(res.issuccess){
            let data = res.data;
            if(data.length > 0){
                let optManagementData = data[0];
                let optOutKeywords = optManagementData['optout_keywords'] !== "" && optManagementData['optout_keywords'] !== null ? parseJSON(optManagementData['optout_keywords']) : this.state.optOutKeywords;
                let optInKeywords = optManagementData['optin_keywords'] !== "" && optManagementData['optin_keywords'] !== null ? parseJSON(optManagementData['optin_keywords']) : this.state.optInKeywords;
                let switchStatus = [parseInt(optManagementData['is_automation_needed']),parseInt(optManagementData['optout_response_needed']),parseInt(optManagementData['optin_response_needed'])];
                let optInMsgId = optManagementData['optin_msg_id'] !== "" && optManagementData['optin_msg_id'] !== null ? optManagementData['optin_msg_id'] : this.state.optInMsgId;
                let optOutMsgId = optManagementData['optout_msg_id'] !== "" && optManagementData['optout_msg_id'] !== null ? optManagementData['optout_msg_id'] : this.state.optOutMsgId;
                let optInResponseMessage = optManagementData['Opt_In_Message'] !== "" && optManagementData['Opt_In_Message'] !== null ? optManagementData['Opt_In_Message'] : this.state.optInResponseMessage;
                let optOutResponseMessage = optManagementData['Opt_Out_Message'] !== "" && optManagementData['Opt_Out_Message'] !== null ? optManagementData['Opt_Out_Message'] : this.state.optOutResponseMessage;
                if(optInResponseMessage !== ""){
                    optInResponseMessage = decodeString(optInResponseMessage, true);
                    optInResponseMessage = replaceStringTohtml(optInResponseMessage);
                    /*let editorState = htmlToDraftBlocks(optInResponseMessage);
                    optInResponseMessage = editorState.getCurrentContent().getPlainText();
                    optInResponseMessage = optInResponseMessage.replace('<\\/span>\\n','');
                    optInResponseMessage = optInResponseMessage.replaceAll('"','');*/
                }
                if(optOutResponseMessage !== ""){
                    optOutResponseMessage = decodeString(optOutResponseMessage, true);
                    optOutResponseMessage = replaceStringTohtml(optOutResponseMessage);
                    /*let editorState = htmlToDraftBlocks(optOutResponseMessage);
                    optOutResponseMessage = editorState.getCurrentContent().getPlainText();
                    optOutResponseMessage = optOutResponseMessage.replace('<\\/span>\\n','');
                    optOutResponseMessage = optOutResponseMessage.replaceAll('"','');*/
                }
                this.setState({
                    optOutKeywords,optInKeywords,switchStatus,optInMsgId,optOutMsgId,optOutResponseMessage,optInResponseMessage
                })
            }

        }
    }

    onSwitchStatusChange = async (e, name, index) => {
        let switchStatus = this.state.switchStatus;
        switchStatus[index] = e.target.checked;
        this.setState({
            switchStatus
        })
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "OPT_MANAGEMENT",
            "SETTINGSNAME" : "SAVE_SWITCH",
            "name" : name,
            "status" : switchStatus[index],
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            showToast("Successfully updated configuration","top-right","success");
        }else{
            handleErrorResponse(res.errormsg);
        }
    }

    addOptOutKeyword = async () => {
        let optOutKeywords = this.state.optOutKeywords;
        optOutKeywords.push("");
        this.setState({
            optOutKeywords
        })
    }

    addOptInKeyword = async () => {
        let optInKeywords = this.state.optInKeywords;
        optInKeywords.push("");
        await this.setState({
            optInKeywords
        })
    }

    removeOptOutKeyword = async (keyword,index) => {
      let {optOutKeywords, requiredindex} = this.state;
      await optOutKeywords.splice(index, 1); 
      await requiredindex.splice(index, 1); 
      this.setState({
        optOutKeywords,
        requiredindex
    })
    }

    removeOptInKeyword = async (keyword,index) => {
        let {optInKeywords, requiredindex} = this.state;
        await requiredindex.splice(index, 1); 
        await optInKeywords.splice(index, 1); 
        this.setState({
            optInKeywords,
            requiredindex
      })
      }

    onInputChange = async (e, index, type) => {
        let inputvalue = e.target.value;
        if(type === 'optout'){
            let optOutKeywords = this.state.optOutKeywords;
            optOutKeywords[index] = inputvalue;
            this.setState({
                optOutKeywords
            })
        } else if(type === 'optin'){
            let optInKeywords = this.state.optInKeywords;
            optInKeywords[index] = inputvalue;
            this.setState({
                optInKeywords
            })
        }
    }

    onSaveSettings = async (e, type) => {
        let ismandatory = true;
        let required = [];
        let keyWords = this.state.optInKeywords;
        if(type === "optout"){
            keyWords = this.state.optOutKeywords;
        }
        
        for(let i = 0; i < keyWords.length; i++){
            if(keyWords[i] === ""){
                ismandatory = false;
                required[i] = type;
            }
        }

        if(ismandatory){
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "OPT_MANAGEMENT",
                "SETTINGSNAME" : "SAVE_SETTINGS",
                "type" : type,
                "keywords" : keyWords,
            }
            let res = await requestApi.processServerRequest(params,"WebV2","post");
            if(res.issuccess){
                showToast("Successfully updated Keywords", "top-right","success");
            }else{
                handleErrorResponse(res.errormsg);
            }
        }else{
            this.setState({
                requiredindex : required,
            })
            showToast("Fill to all Inbox", "top-right", "warning");
        }
    }

    configureResponseMessageModal = (index, type) => {
        let modalStatus = this.state.modalStatus;
        modalStatus[index] = true;
        this.setState({
            modalStatus, currentOptType : type
        })
    }

    onTemplateSaveAction = async (isModalEnabled, messageId) => {
        let currentOptType = this.state.currentOptType;
        let modalStatus = this.state.modalStatus;
        let modalIndex = 0;
        if(currentOptType === "optin"){
            modalIndex = 1;
        }
        modalStatus[modalIndex] = isModalEnabled;
        this.setState({
            modalStatus, currentOptType : ""
        })
        if(messageId !== "" && messageId !== undefined) {
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "OPT_MANAGEMENT",
                "SETTINGSNAME" : "SAVE_RESPONSE_CONFIG",
                "TYPE": currentOptType,
                "MESSAGE_ID": messageId,
            };

            let response = await requestApi.processServerRequest(params, "WebV2", "post");
            if (response.issuccess) {
                this.loadOptManagementData();
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }

    render() {
        let optInKeyWords = this.state.optInKeywords;
        let optOutKeyWords = this.state.optOutKeywords;
        let switchStatus = this.state.switchStatus;
        let requiredindex = this.state.requiredindex;
        let optOutData = {};
        let optInData = {};
        if(this.state.optOutResponseMessage !== "") {
            optOutData['welcomeTxt'] = this.state.optOutResponseMessage;
        }
        if(this.state.optInResponseMessage !== "") {
            optInData['welcomeTxt'] = this.state.optInResponseMessage;
        }
        let {useForm} = this.props;
        
        return (
            <>
                <Fragment>
                    <div className={'opt-management-container kv-main-wrapper h100per w-100'}>
                        <div className={'optout-modal'}>
                            <QuickReplyOperations
                                key={randstr('quickrep_')}
                                showActionModal={this.state.modalStatus[0]}
                                quickReplyId={this.state.optOutMsgId}
                                toggleActionsModal={this.onTemplateSaveAction}
                                type={"optout_message"}
                                useForm={useForm}
                            />
                        </div>
                        <div className={'optin-modal'}>
                            <QuickReplyOperations
                                key={randstr('quickrep_')}
                                showActionModal={this.state.modalStatus[1]}
                                quickReplyId={this.state.optInMsgId}
                                toggleActionsModal={this.onTemplateSaveAction}
                                type={"optin_message"}
                                useForm={useForm}
                            />
                        </div>
                        <Card className="main-card optmc">
                            <CardBody>
                                <div className={""}>
                                    <h4 className={'optmanagement-h4'}>Opt-out from Automation Messages </h4>
                                    <div className={'flex'}>
                                        <div className={'flex col-md-8 align-center'}>
                                            <span>Enable this if you don't wish to send automation messages to opted-out contacts.</span>
                                        </div>
                                        <div className={'flex justify-end col-md-4'}>
                                            <Switch name={'automation_needed'} checked={switchStatus[0]} onChange={(e) => {this.onSwitchStatusChange(e,'automation_needed',0)}} />
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card className="main-card optmc">
                            <CardBody>
                                <div className={'flex col-md-12'}>
                                    <div className={'col-md-6'}>
                                        <h4 className={'optmanagement-h4 mt-2'}>Opt-out Keywords</h4>
                                        <br/>
                                        <div className={'pr-2 optdesc-p'}><span>The user will have to type exactly one of these messages on which they should be automatically opted-out</span></div>
                                        <div className={'keyword-controls col-md-6'}>
                                            {
                                                optOutKeyWords.map((keyword, index) => {
                                                    return (
                                                        <div className={`input-variation`}>
                                                        <input 
                                                            type={'text'} 
                                                            onChange={(e) => {
                                                                this.onInputChange(e, index, 'optout')
                                                            }} 
                                                            name={'optout-keyword-'+index} 
                                                            value={keyword} 
                                                            className={cx('form-control mb-3', {"opt-manage-inbox-required" : keyword === "" && requiredindex[index] && requiredindex[index] === "optout"})}
                                                        />
                                                        <span className={`input-variation-remove ml-1`}>
                                                            <FontAwesomeIcon 
                                                                icon={faXmark} 
                                                                className={`mr-1 ${ keyword == "Stop" || keyword == "Unsubscribe" ? 'hide' : ''}`} 
                                                                onClick={()=>this.removeOptOutKeyword(keyword,index)}
                                                            />
                                                        </span>
                                                       </div>
                                                    )
                                                })
                                            }
                                            <div className={'button-panel'}>
                                                <a className={`cursor-pointer option-addmore ${optOutKeyWords.length > 4 ? 'btn-disabled' : ''}`} onClick={(e) => {this.addOptOutKeyword(e)}}><FontAwesomeIcon icon={faPlus} /> <span>Add More</span></a>
                                                <Button className={'mt-3'}  onClick={(e) => {this.onSaveSettings(e, 'optout')}} color={"success"}>Save Settings</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-md-6'}>
                                        <div className={'flex'}>
                                            <div className={'flex col-md-6 align-center'}>
                                            <h4 className={'optmanagement-h4'}>Opt-out Response</h4>
                                            </div>
                                            <div className={'flex justify-end col-md-6'}>
                                                <Switch name={'optout_needed'} checked={switchStatus[1]} onChange={(e) => {this.onSwitchStatusChange(e,'optout_needed',1)}} />
                                                <Button color={"light"} onClick={(e) => {this.configureResponseMessageModal(0,'optout')}}><FontAwesomeIcon icon={faPencil} /> Configure</Button>
                                            </div>
                                        </div>
                                        <div className={'mt-2'}><span >Setup a response message for opt-out user keywords</span></div>
                                        <div className={'settings-content optmanage-settings'}>
                                            <div className={'content-data content-preview'}>
                                <span className="message-content" dir="auto">
                                    <div dangerouslySetInnerHTML={{ __html: this.state.optOutResponseMessage }} />
                                </span>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </CardBody>
                        </Card>
                        <Card className="main-card optmc">
                            <CardBody>
                                <div className={'flex col-md-12'}>
                                    <div className={'col-md-6'}>
                                        <h4 className={'optmanagement-h4 mt-2'}>Opt-in Keywords</h4>
                                        <br/>
                                        <div className={'pr-2 optdesc-p'}><span>The user will have to type exactly one of these messages on which they should be automatically opted-in</span></div>

                                        <div className={'keyword-controls col-md-6'}>
                                            {
                                                optInKeyWords.map((keyword, index) => {
                                                    return (
                                                        <div className={`input-variation`}>
                                                            <input 
                                                                type={'text'} 
                                                                onChange={(e) => {
                                                                    this.onInputChange(e, index, 'optin')
                                                                }} name={'optin-keyword-'+index} 
                                                                value={keyword} 
                                                                className={cx('form-control mb-3', {"opt-manage-inbox-required" : keyword === "" && requiredindex[index] && requiredindex[index] === "optin"})}
                                                            />
                                                            <span className={`input-variation-remove ml-1`}>
                                                                <FontAwesomeIcon 
                                                                    icon={faXmark} 
                                                                    className={`mr-1 ${ keyword == "Start" || keyword == "Subscribe" ? 'hide' : ''}`}
                                                                    onClick={()=>this.removeOptInKeyword(keyword,index)}
                                                                />
                                                            </span>
                                                        </div>
                                                        )
                                                })
                                            }
                                            <div className={'button-panel'}>
                                                <a className={`cursor-pointer option-addmore ${optInKeyWords.length > 4 ? 'btn-disabled' : ''}`} onClick={(e) => {this.addOptInKeyword(e)}}><FontAwesomeIcon icon={faPlus} /> <span>Add More</span></a>
                                                <Button className={'mt-3'} onClick={(e) => {this.onSaveSettings(e, 'optin')}} color={"success"}>Save Settings</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-md-6'}>
                                        <div className={'flex'}>
                                            <div className={'flex col-md-6 align-center'}>
                                                <h4 className={'optmanagement-h4'}>Opt-in Response</h4>
                                            </div>
                                            <div className={'flex justify-end col-md-6'}>
                                                <Switch name={'optin_needed'} checked={switchStatus[2]} onChange={(e) => {this.onSwitchStatusChange(e,'optin_needed',2)}} />
                                                <Button color={"light"} onClick={(e) => {this.configureResponseMessageModal(1,'optin')}}><FontAwesomeIcon icon={faPencil} /> Configure</Button>
                                            </div>
                                        </div>
                                        <div className={'mt-2'}><span >Setup a response message for opt-in user keywords</span></div>
                                        <div className={'settings-content optmanage-settings'}>
                                            <div className={'content-data content-preview'}>
                                <span className="message-content" dir="auto">
                                    <div dangerouslySetInnerHTML={{ __html: this.state.optInResponseMessage }} />
                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Fragment>
            </>
        )
    }
}

export default OptInOutManagement;
